import { UseFormReturn } from 'react-hook-form'

import { ExitFarmSwitch } from '../components/claim-rewards-switch/ExitFarmSwitch'
import { TransactionOverview } from '../components/transaction-overview/TransactionOverview'
import { TxOverview } from '../logic/createTxOverview'
import { ExitFarmSwitchInfo } from '../logic/useUnstakeDialog'
import { TokenWithBalance } from '@/domain/common/types'
import { ActionsViewState } from '@/features/actions/types'
import { ActionsView } from '@/features/actions/views/ActionsView'
import { FormAndOverviewWrapper } from '@/features/dialogs/common/components/FormAndOverviewWrapper'
import { DialogForm } from '@/features/dialogs/common/components/form/DialogForm'
import { MultiPanelDialog } from '@/features/dialogs/common/components/MultiPanelDialog'
import { AssetInputSchema } from '@/features/dialogs/common/logic/form'
import { FormFieldsForDialog } from '@/features/dialogs/common/types'
import { DialogTitle } from '@/ui/atoms/dialog/Dialog'

export interface StakeViewProps {
  selectableAssets: TokenWithBalance[]
  assetsFields: FormFieldsForDialog
  form: UseFormReturn<AssetInputSchema>
  txOverview: TxOverview
  exitFarmSwitchInfo: ExitFarmSwitchInfo
  actionsViewState: ActionsViewState
}

export function UnstakeView({
  selectableAssets,
  assetsFields,
  form,
  txOverview,
  exitFarmSwitchInfo,
  actionsViewState,
}: StakeViewProps) {
  return (
    <MultiPanelDialog>
      <DialogTitle>Withdraw from SPK Farm</DialogTitle>

      <FormAndOverviewWrapper>
        <DialogForm form={form} assetsFields={assetsFields} selectorAssets={selectableAssets} />
        <TransactionOverview txOverview={txOverview} selectedToken={assetsFields.selectedAsset} />
      </FormAndOverviewWrapper>

      {exitFarmSwitchInfo.showSwitch && <ExitFarmSwitch {...exitFarmSwitchInfo} />}

      <ActionsView state={actionsViewState} actionsGridLayout="compact" allowChangeWhenActionsInProgress={false} />
    </MultiPanelDialog>
  )
}
